import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { GrWaveLoaderSize, GrWaveLoaderTone } from './wave-loader.types';

@Component({
  selector: 'gr-wave-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents;' },
  template: `
    <span
      [class]="rootClasses()"
      role="status"
      [attr.aria-label]="ariaLabel() || 'Loading'"
    >
      <span class="gr-wave-loader-bar" aria-hidden="true"></span>
      <span class="gr-wave-loader-bar" aria-hidden="true"></span>
      <span class="gr-wave-loader-bar" aria-hidden="true"></span>
      <span class="gr-wave-loader-bar" aria-hidden="true"></span>
      <span class="gr-wave-loader-bar" aria-hidden="true"></span>
    </span>
  `,
})
export class GrWaveLoaderComponent {
  readonly size = input<GrWaveLoaderSize>('md');
  readonly tone = input<GrWaveLoaderTone>('brand');
  readonly ariaLabel = input<string>('');
  readonly styleClass = input<string>('');

  protected readonly rootClasses = computed<string>(() => {
    const classes = [
      'gr-wave-loader',
      `gr-wave-loader--${this.size()}`,
      `gr-wave-loader--${this.tone()}`,
      'inline-flex',
      'items-center',
      'justify-between',
    ];
    const extra = this.styleClass();
    if (extra) classes.push(extra);
    return classes.join(' ');
  });
}
